import { Component } from 'react'
import { withRouterProps } from '../../../utils'

class NotFound extends Component {
  componentDidMount() {
    this.props.navigate('/welcome/accept-terms', { replace: true })
  }

  render() {
    return <div />
  }
}

export default withRouterProps(NotFound)
